import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FacultyMedicalProcedureModel } from '../../../model/faculty_medical_procedure.model';
import { FacultyMedicalProcedureParameterModel } from '../../../model/faculty_medical_procedure_parameter';
import { FacultyMedicalProcedureParameterService } from '../../../providers/faculty_medical_procedure_parameter.service';

@Component({
  selector: 'app-parameter-edit-dialog',
  templateUrl: './parameter-edit-dialog.component.html',
  styleUrls: ['./parameter-edit-dialog.component.css']
})
export class ParameterEditDialogComponent implements OnInit {

  selectedItem:FacultyMedicalProcedureParameterModel;
  errorMessage: string = '';
  isLoading: boolean = true;
  mItems:FacultyMedicalProcedureParameterModel[]; 
  mFacultyMedicalProcedure:FacultyMedicalProcedureModel

  constructor(private fb: FormBuilder, private mApiService:FacultyMedicalProcedureParameterService,
    private dialogRef: MatDialogRef<ParameterEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any) {
      this.mFacultyMedicalProcedure=new FacultyMedicalProcedureModel();
     }

    onNoClick(): void {
      this.dialogRef.close();
    }

  ngOnInit(): void {
    this.selectedItem = this.data;

   
  }

  saveEdit(){


         
    this.mApiService
    .editItem(this.selectedItem)
    .subscribe(
     p=> {
      this.getItemsList(   this.mFacultyMedicalProcedure.Id);
      // this.varShowEditDialog=false 
    },
     e => this.errorMessage = e,
     ()=>this.isLoading=false
   )

}


getItemsList(id:string)
{
     this.mItems=[];
     this.isLoading=true;
     

         this.mApiService.getItems(id)
         .subscribe(
           p=>this.mItems=p,
           e => this.errorMessage = e,
           ()=>this.isLoading=false
         )

    
}


}
